// extracted by mini-css-extract-plugin
export default {"legend":"s1Gg6QNKFn5LfUmMDswL","entry":"ANw6jVyCnxfatC1faz9K","swatch":"bcpXeADQZErsfdwG8hCW"};